import { useTranslation } from "react-i18next";

import { PlusTag } from "../PlusTag";
import { Container } from "./styles";

type Props = {
  onClick: () => void;
  /** Replaces the default pitch (e.g. the /sites banner's own headline). */
  title?: string;
  /** Smaller line under the title. */
  description?: string;
  /** Replaces the default CTA label ("Conheça"). */
  cta?: string;
  /** One compact row on desktop (tag, text, CTA), for full-width spots like the /sites banner. */
  compact?: boolean;
  /** Replaces the "✦ Keepo Plus" tag (the same bar selling something else, e.g. a domain). */
  tag?: string;
  className?: string;
};

/** Keepo PLUS highlight block, shared by the sidebar and the Keepo dashboard. */
export const PlusPromo = ({ onClick, title, description, cta, compact, className, tag }: Props) => {
  const { t } = useTranslation();

  return (
    <Container type="button" $compact={compact} onClick={onClick} className={className}>
      <PlusTag className="tag">{tag || "✦ Keepo Plus"}</PlusTag>
      <span className="text">
        <p>{title || t("pages.subscription.header.description")}</p>
        {description && <span className="description">{description}</span>}
      </span>
      <span className="cta">{cta || t("components.bannerPremium.buttonTitle")} →</span>
    </Container>
  );
};
